<template>
  <div class="poll-layout">
    <!-- <v-row no-gutters align="center" justify="center">
      <v-col class="">
        <span class="poll-title">{{ $t('pollDialogTitle') }}</span>
      </v-col>
    </v-row> -->
    <!-- Input Question -->
    <v-row no-gutters align="center" justify="center">
      <v-col class="">
        <span class="poll-sub-title">{{ $t('pollDialogQuestionTitle') }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" justify="center">
      <v-col class="mt-0 pt-2">
        <div class="input-div">
          <v-text-field
            :label="$t('pollDialogQuestionHint')"
            dark
            dense
            hide-details="auto"
            height="45px"
            class="txtf-poll-question"
            :placeholder="$t('pollDialogQuestionHint')"
            type="input"
            v-model="contentData.pollQuestion"
            solo
            background-color="#1a272e"
            :rules="[rules.required]"
            flat
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <!-- Input Choice -->
    <v-row no-gutters align="center" justify="center">
      <v-col class="mt-4">
        <span class="poll-sub-title">{{ $t('pollDialogChoiceTitle') }}</span>
      </v-col>
    </v-row>
    <v-row class="container-poll-contents" no-gutters align="center" justify="center">
      <v-col cols="12" v-for="(item, n) in contentData.pollChoices" :key="n" class="pt-4 mt-0">
        <v-text-field
          :label="$t('enterChoice')"
          :placeholder="$t('enterChoice')"
          v-model="contentData.pollChoices[n].title"
          dark
          height="45px"
          dense
          hide-details="auto"
          :maxlength="100"
          :ref="`choice${n}`"
          :rules="n < 2 ? [rules.required] : []"
          solo
          flat
          background-color="#1a272e"
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="auto" class="ml-2 mt-5">
        <span v-if="n >= 2" class="material-icons-round" style="width: 20px; cursor: pointer" @click="removeItem(n)">
          remove
        </span>
        <div v-else style="width: 20px"></div>
      </v-col> -->
    </v-row>

    <!-- <v-row no-gutters v-if="contentData.pollChoices.length <= maxCount"> -->
    <v-row no-gutters>
      <v-col class="pt-0 pb-0 mt-3 text-center">
        <v-btn text @click="addItem()">
          <v-icon large color="white">mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- <v-row align="center" justify="center" class="">
      <v-col align="start" class="mb-7" style="color: #eee; font-weight: 700">
        {{ 'Notification' }}
      </v-col>
      <v-col align="end" class="mb-7">
        <notification-dialog
          @customRecipientList="customRecipientList"
          @chkboxWs="chkboxWs"
          @chkboxPostComment="chkboxPostComment"
        ></notification-dialog>
      </v-col>
    </v-row> -->

    <!-- <v-row no-gutters class="mt-0 pb-8" justify="center" align="center">
      <v-col class="row-thumbnail" align="center" no-gutters>
        <v-btn block color="#96a7af" width="100" @click="$emit('discardPreview')">
          {{ $t('discard') }}
        </v-btn>
      </v-col>
      <v-col class="row-thumbnail ml-4" align="center" no-gutters>
        <v-btn
          color="#27cd8b"
          width="100"
          block
          :loading="isPollUploadLoading"
          :disabled="!contentData.pollQuestion || contentData.pollQuestion === '' || this.valid === false"
          @click="uploadPoll()"
        >
          {{ $t('done') }}
        </v-btn>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
// import NotificationDialog from '@/views/modal/NotificationDialog'

export default {
  name: 'PollDialog',
  components: {
    // NotificationDialog,
  },
  data() {
    return {
      // maxCount: 10,
      contentData: {
        clipType: 'poll',
        type: 'poll',
        pollQuestion: '',
        pollChoices: [
          { title: '', voterList: [] },
          { title: '', voterList: [] },
        ],
      },
      isPollUploadLoading: false,
      rules: {
        required: (value) => !!value || 'Required',
      },
    }
  },
  methods: {
    customRecipientList(val) {
      this.$emit('customRecipientList', val)
    },
    chkboxPostComment(val) {
      this.$emit('chkboxPostComment', val)
    },
    chkboxWs(val) {
      this.$emit('chkboxWs', val)
    },
    addItem() {
      this.contentData.pollChoices.push({ title: '', voterList: [] })
    },
    removeItem(index) {
      this.contentData.pollChoices.splice(index, 1)
    },
    uploadPoll() {
      this.isPollUploadLoading = true
      const tempList = []

      for (let pollChoice of this.contentData.pollChoices) {
        const title = pollChoice.title
        if (title && title !== '') tempList.push(pollChoice)
      }

      this.contentData.pollChoices = tempList
      this.$emit('templateUpload', this.contentData)
    },
  },
  computed: {
    mtInfo() {
      return this.$store.getters.currentMt
    },
    valid() {
      let valid = true
      if (this.contentData && this.contentData.pollChoices && this.contentData.pollChoices.length > 0) {
        for (let index in this.contentData.pollChoices) {
          if (
            (Number(index) === 0 || Number(index) === 1) &&
            (!this.contentData.pollChoices[index] ||
              !this.contentData.pollChoices[index].title ||
              this.contentData.pollChoices[index].title === '')
          ) {
            valid = false
          }
        }
      }
      return valid
    },
  },
  watch: {
    contentData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('contentData', val)
      },
    },
  },
}
</script>

<style scoped>
.poll-layout {
  min-width: 360px;
  width: 50vw;
  max-width: 500px;
  /* background-color: #21343b; */
  /* border-radius: 10px; */
}
.container-poll-contents {
  max-height: 250px;
  overflow-y: auto;
}
::-webkit-scrollbar {
  width: 15px;
}
::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
}
span {
  color: white;
  font-weight: bold;
}
#poll {
  font-size: 20px;
}
.poll-title {
  font-size: 24px;
}
.poll-sub-title {
  font-size: 18px;
}
#text-length {
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: right;
  transform: translate(-20px, -30px);
  font-weight: normal;
  color: #869399;
}
.txtf-poll-question >>> .el-textarea__inner {
  background: #1a272e;
  text-align: center !important;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  resize: none;
}

.row-thumbnail >>> .v-btn * {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: none;
  color: white;
  font-weight: bold;
}
</style>
